const refs = new Map();
export const registerRef = (id, ref) => refs.set(id, ref);
export const getRefs = () => refs;
